import { render } from "./g-messages-question.vue?vue&type=template&id=703dccc0&ts=true"
import script from "./g-messages-question.vue?vue&type=script&lang=tsx"
export * from "./g-messages-question.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__